<template>
	<div class="menu-container">
		<CompactMenuItem
			v-for="menuItem in menuItems"
			:key="menuItem.key"
			:menuItem="menuItem"
			@click="onClick(menuItem)"
		/>
		<LocaleChooser2 />
	</div>
</template>

<script>
import { computed, toRef } from 'vue';
import CompactMenuItem from '@/components/common/CompactMenuItem';
import LocaleChooser2 from '@/components/common/LocaleChooser2';
import { MAIN_MENU_REWRITES } from '@/components/top_level/navigationConsts/mainMenuRewrites';

export default {
	components: {
		CompactMenuItem,
		LocaleChooser2,
	},
	emits: ['select'],
	props: ['selectedKey', 'items'],
	setup(props, { emit }) {
		const selectedKeyRef = toRef(props, 'selectedKey');
		const itemsRef = toRef(props, 'items');
		const checkSelected = (itemKey) => {
			if (selectedKeyRef.value === itemKey) {
				return true;
			}
			if (selectedKeyRef.value in MAIN_MENU_REWRITES) {
				return MAIN_MENU_REWRITES[selectedKeyRef.value] === itemKey;
			}
			return false;
		}

		const menuItems = computed(() =>
			itemsRef.value.map(item => ({
				key: item.key,
				selected: checkSelected(item.key),
			}))
		);

		const onClick = (item) => {
			// если кликнули по выбранному пункту, то делаем как бы toggle, и закрываем окно, переходя на карту
			emit('select', selectedKeyRef.value === item.key ? 'home-map' : item.key);
		}

		return {
			menuItems,
			onClick,
		};
	},
};
</script>

<style scoped>
.menu-container {
	position: absolute;
	inset-block-start: 16px;
	inset-inline-end: 16px;
	display: flex;
	z-index: 5;
}

@media (max-width: 900px) {
	.menu-container {
		flex-direction: column;
	}
}
</style>
